import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

interface LoaUser {
  firstName: string;
  middleName: string;
  lastName: string;
  id: number;
  dob: string;
  email: string;
  mobile: string;
  gender: string;
  file_id: number;
  approval_code: string;  
}

@Injectable({
  providedIn: "root"
})
export class LoaService {
  private _currentUser: BehaviorSubject<LoaUser>;

  constructor() {
    this._currentUser = new BehaviorSubject<LoaUser>(this.getUserFromStorage());
  }

  get currentUser(): Observable<LoaUser> {
    return this._currentUser.asObservable();
  }

  updateUser(user: LoaUser): void {
    localStorage.setItem("currentUser", JSON.stringify(user));
    this._currentUser.next(user); 
  }

  private getUserFromStorage(): LoaUser {
    const user = localStorage.getItem("currentUser");
    return user
      ? JSON.parse(user)
      : { firstName: "", middleName: "", lastName: "", id: 0, dob: "", email: "", mobile: "", gender: "", file_id: 0, approval_code: "" };
  }

  resetUser(): void {
    localStorage.removeItem("currentUser");
    this._currentUser.next({ firstName: "", middleName: "", lastName: "", id: 0, dob: "", email: "", mobile: "", gender: "", file_id: 0, approval_code: "" });
  }
}
